import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["modal"]

  connect() {
    $(this.modalTarget).modal("show")
  }

  hideModal() {
    this.element.parentElement.removeAttribute("src")
    $(this.modalTarget).modal("hide")
    //this.modalTarget.remove()
  }

  closeWithKeyboard(e) {
    if (e.code == "Escape") {
      this.hideModal()
    }
  }

  closeBackground(e) {
    if (e && this.modalTarget.contains(e.target)) {
      return
    }
    this.hideModal()
  }


  submitEnd(e) {
    if (e.detail.success) {
      this.hideModal()
    }
  }
}
